"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.zoomToDistrict = exports.getCamera = exports.removeActivePins = exports.rootSearchMapSagas = exports.defaultViewport2 = exports.defaultViewport = void 0;
var SearchMapAction_1 = require("@/pages/search/actions/SearchMapAction");
var effects_1 = require("redux-saga/effects");
var myokay_map3_1 = require("@okay/myokay-map3");
var SearchApi_1 = require("@/api/remote/public/SearchApi");
var GlobalCallSaga_1 = require("@/pages/common/sagas/GlobalCallSaga");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var WindowApi_1 = require("@/api/browser/WindowApi");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var getFittingCameraFromPoints_1 = require("@/utils/getFittingCameraFromPoints");
var ResultAction_1 = require("@/pages/search/actions/sfilter/ResultAction");
var searchResponseToResultPage_1 = require("@/transformers/searchResponseToResultPage");
var RootSearchMapCallSaga_1 = require("@/pages/search/sagas/RootSearchMapCallSaga");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var SearchQueryAction_1 = require("@/pages/search/actions/sfilter/SearchQueryAction");
var stateToSearchQuery_1 = require("@/transformers/stateToSearchQuery");
var SearchAction_1 = require("@/pages/search/actions/SearchAction");
var HfilterAction_1 = require("@/pages/search/actions/HfilterAction");
var SavePropertiesApiSaga_1 = require("@/pages/saveproperties/sagas/api/SavePropertiesApiSaga");
var UserPropertiesCrud_1 = require("@/pages/saveproperties/sagas/UserPropertiesCrud");
var latLngContain_1 = require("@/utils/latLngContain");
var StorageApi_1 = require("@/api/browser/StorageApi");
var getDistricts = function (state, districtIds) { return state.hfilter.districts.filter(function (it) { return districtIds.indexOf(it.id) > -1; }); };
var getMapHasPin = function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.mapsearch) === null || _a === void 0 ? void 0 : _a.cacheData) === null || _b === void 0 ? void 0 : _b.pins.length) !== null && _c !== void 0 ? _c : false; };
var getResultPageTranslation = function (state) { return state.resultT; };
var getInitAggregatedData = function (state) { return state.mapsearch.initAggregatedData; };
var getListingType = function (state) { return state.hfilter.listingType; };
var getCamera = function (state) { return state.mapsearch.camera; };
exports.getCamera = getCamera;
var getCurrentActivePins = function (state) { return state.mapsearch.currentActivePins; };
var getHasKeyword = function (state) { return state.hfilter.keyword.length > 0; };
var getSelectedDistrictLocations = function (state) {
    return state.hfilter.districts
        .filter(function (it) { return it.selected; })
        .map(function (it) { return ({ id: it.id, location: it.location }); });
};
var isKeywordPropertyId = function (state) {
    var keyword = state.hfilter.keyword;
    return "" + Number(keyword) === keyword;
};
exports.defaultViewport = {
    bound: {
        ne: { lat: 22.580773, lng: 114.405760 },
        sw: { lat: 22.176058, lng: 113.804769 },
    },
    zoom: 12,
};
exports.defaultViewport2 = {
    bound: {
        ne: { lat: 22.580773, lng: 114.405760 },
        sw: { lat: 22.176058, lng: 113.804769 },
    },
    zoom: 9,
};
var viewportToPinType = function (zoom) {
    var level = myokay_map3_1.layerDefinitionDefault.find(function (it) { return it.zoom < zoom; }).level;
    if (level === myokay_map3_1.ZoomLevel.AREA || level === myokay_map3_1.ZoomLevel.DISTRICT)
        return myokay_map3_1.PinTypes.BUBBLE;
    if (level === myokay_map3_1.ZoomLevel.BUILDING) {
        return myokay_map3_1.PinTypes.BUBBLE_LEG;
    }
    if (level === myokay_map3_1.ZoomLevel.PROPERTY) {
        return myokay_map3_1.PinTypes.CALLOUT;
    }
    return myokay_map3_1.PinTypes.CALLOUT;
};
var reponseToPins = function (response, viewport) {
    if (!viewport)
        return [];
    var type = viewportToPinType(viewport.zoom);
    if (!response.aggregatedData)
        return [];
    return response.aggregatedData.map(function (it) { return ({
        type: type,
        value: it,
        lat: Number(("" + it.latitude).trim()),
        lng: Number(("" + it.longitude).trim()),
        count: it.count,
    }); });
};
var watchInitCamera = function () {
    var isSmallScreen, camera;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(WindowApi_1.getIsMobile)];
            case 2:
                isSmallScreen = _a.sent();
                return [4 /*yield*/, effects_1.select(getCamera)];
            case 3:
                camera = _a.sent();
                if (!(!camera || !camera.center)) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.setCameraAndMinZoom(isSmallScreen ? __assign(__assign({}, myokay_map3_1.defaultCamera), { zoom: 10 }) : myokay_map3_1.defaultCamera, isSmallScreen ? 10 : 11))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchMapViewInit = function () {
    var payload, isActive;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.setMapActive)];
            case 1:
                payload = (_a.sent()).payload;
                isActive = payload;
                if (!isActive) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.setMapInit(true))];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var applyClusterConfig = function (viewport) {
    var clusterConfig;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(myokay_map3_1.getDefaultClusterConfig, viewport)];
            case 1:
                clusterConfig = _a.sent();
                return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.setClusterConfig(clusterConfig))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchDebounceSearch = function () {
    var DEBOUNCE_MS, task, _loop_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                DEBOUNCE_MS = 800;
                task = null;
                _loop_1 = function () {
                    var payload, viewport;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, effects_1.take(SearchQueryAction_1.default.DEBOUNCE_SEARCH)];
                            case 1:
                                payload = (_a.sent()).payload;
                                viewport = payload.viewport;
                                if (!task) return [3 /*break*/, 3];
                                return [4 /*yield*/, effects_1.cancel(task)];
                            case 2:
                                _a.sent();
                                _a.label = 3;
                            case 3: return [4 /*yield*/, effects_1.fork(function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, effects_1.delay(DEBOUNCE_MS)];
                                            case 1:
                                                _a.sent();
                                                return [4 /*yield*/, effects_1.put(SearchQueryAction_1.default.search(viewport))];
                                            case 2:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                })];
                            case 4:
                                task = _a.sent();
                                return [2 /*return*/];
                        }
                    });
                };
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_1()];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnViewportChanged = function () {
    var payload, aggregatedData, type, multiplier_1, action2, viewport;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(SearchMapAction_1.default.ON_VIEWPORT_CHANGED)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.call(applyClusterConfig, payload)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getInitAggregatedData)];
            case 3:
                aggregatedData = _a.sent();
                if (!(aggregatedData && aggregatedData.length)) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.select(getListingType)];
            case 4:
                type = _a.sent();
                multiplier_1 = type === SfilterTypeGroup_1.ListingPurposeType.Sale ? 1 : 1000;
                return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.handleResponse({ aggregatedData: aggregatedData.map(function (it) { return (__assign(__assign({}, it), { minPrice: it.minPrice * multiplier_1, maxPrice: it.maxPrice * multiplier_1 })); }) }, payload))];
            case 5:
                _a.sent();
                return [3 /*break*/, 9];
            case 6: 
            // non server-side rendered
            return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.addCacheData(null))];
            case 7:
                // non server-side rendered
                _a.sent();
                return [4 /*yield*/, effects_1.put(SearchQueryAction_1.default.search())];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.preloadAreaDistrict())];
            case 10:
                _a.sent();
                _a.label = 11;
            case 11:
                if (!true) return [3 /*break*/, 15];
                return [4 /*yield*/, effects_1.take(SearchMapAction_1.default.ON_VIEWPORT_CHANGED)];
            case 12:
                action2 = _a.sent();
                return [4 /*yield*/, effects_1.call(applyClusterConfig, action2.payload)];
            case 13:
                _a.sent();
                viewport = action2.payload;
                return [4 /*yield*/, effects_1.put(SearchQueryAction_1.default.debounceSearch(viewport))];
            case 14:
                _a.sent();
                return [3 /*break*/, 11];
            case 15: return [2 /*return*/];
        }
    });
};
var watchHandleResponse = function () {
    var payload, viewport, _a, response, pins;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!true) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.take(SearchMapAction_1.default.HANDLE_RESPONSE)];
            case 1:
                payload = (_b.sent()).payload;
                if (!payload.viewport) return [3 /*break*/, 2];
                _a = payload.viewport;
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, effects_1.select(RootSearchMapCallSaga_1.getViewport)];
            case 3:
                _a = _b.sent();
                _b.label = 4;
            case 4:
                viewport = _a;
                response = payload.response;
                return [4 /*yield*/, effects_1.call(reponseToPins, response, viewport)];
            case 5:
                pins = _b.sent();
                return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.setCurrentActivePins(null, null))];
            case 6:
                _b.sent();
                return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.addCacheData({ pins: pins, viewport: viewport }))];
            case 7:
                _b.sent();
                return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
};
var getMapSearchResponse = function (viewport) {
    var state, pageSize, stateWithArea, searchQuery;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select()];
            case 1:
                state = _a.sent();
                return [4 /*yield*/, effects_1.select(GlobalCallSaga_1.getResultPageSize)];
            case 2:
                pageSize = _a.sent();
                stateWithArea = __assign(__assign({}, state), { mapsearch: __assign(__assign({}, state.mapsearch), { viewport: viewport }) });
                return [4 /*yield*/, effects_1.call(stateToSearchQuery_1.stateToSearchQuery, stateWithArea, pageSize)];
            case 3:
                searchQuery = _a.sent();
                return [4 /*yield*/, effects_1.call(SearchApi_1.searchQueryApi, searchQuery)];
            case 4: return [2 /*return*/, _a.sent()];
        }
    });
};
var watchPreloadAreaDistrict = function () {
    var state, areaViewport, areaResponse, districtViewport, districtResponse;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.take(SearchMapAction_1.default.PRELOAD_AREA_DISTRICT)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select()];
            case 2:
                state = _a.sent();
                if (state.hfilter.districts.filter(function (it) { return it.selected; }).length > 0)
                    return [3 /*break*/, 0];
                areaViewport = exports.defaultViewport;
                return [4 /*yield*/, effects_1.call(getMapSearchResponse, areaViewport)];
            case 3:
                areaResponse = _a.sent();
                if (!areaResponse) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.handleResponse(areaResponse, areaViewport))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5:
                districtViewport = exports.defaultViewport2;
                return [4 /*yield*/, effects_1.call(getMapSearchResponse, districtViewport)];
            case 6:
                districtResponse = _a.sent();
                if (!districtResponse) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.handleResponse(districtResponse, districtViewport))];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [3 /*break*/, 0];
            case 9: return [2 /*return*/];
        }
    });
};
var removeActivePins = function () {
    var activePinInfo, viewport, activePins, forceUpdate;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(getCurrentActivePins)];
            case 1:
                activePinInfo = _a.sent();
                if (!activePinInfo || !activePinInfo.pins || !activePinInfo.viewport)
                    return [2 /*return*/];
                viewport = activePinInfo.viewport;
                activePins = activePinInfo.pins;
                forceUpdate = true;
                return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.addCacheData({ pins: activePins.map(function (it) { return (__assign(__assign({}, it), { popupActive: false })); }), viewport: viewport, forceUpdate: forceUpdate }))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.setCurrentActivePins(null, null))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setNoscroll(false))];
            case 4:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
exports.removeActivePins = removeActivePins;
var watchRemoveActivePins = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(SearchMapAction_1.default.REMOVE_ACTIVE_PINS)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(removeActivePins)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var getPropertiesForBuildingIds = function (buildingIds) {
    var state, pageSize, language, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select()];
            case 1:
                state = _a.sent();
                return [4 /*yield*/, effects_1.select(GlobalCallSaga_1.getResultPageSize)];
            case 2:
                pageSize = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 3:
                language = _a.sent();
                return [4 /*yield*/, effects_1.call(SearchApi_1.getAggregateDataForBuilding, buildingIds, state, language, pageSize)];
            case 4:
                response = _a.sent();
                return [2 /*return*/, response.aggregatedData ? response.aggregatedData : []];
        }
    });
};
var fetchPropertiesToPin = function (pin) {
    var isCluster, newPin, pins, aggregatedData, _loop_2, i, aggregatedData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                isCluster = pin.isCluster;
                newPin = __assign({}, pin);
                if (!isCluster) return [3 /*break*/, 3];
                pins = pin.value;
                if (!pins.map(function (it) { return it.value.properties; }).filter(function (it) { return !it; }).length) return [3 /*break*/, 2];
                return [4 /*yield*/, effects_1.call(getPropertiesForBuildingIds, pins.map(function (it) { return (it.value).id; }))];
            case 1:
                aggregatedData = _a.sent();
                _loop_2 = function (i) {
                    var pin_1 = pins[i].value;
                    if (!pin_1.properties) {
                        newPin.value[i].value.properties = aggregatedData.find(function (it) { return it.id === pin_1.id; }).properties;
                    }
                };
                for (i in pins) {
                    _loop_2(i);
                }
                _a.label = 2;
            case 2: return [3 /*break*/, 5];
            case 3:
                if (!!pin.value.properties) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.call(getPropertiesForBuildingIds, [pin.value.id])];
            case 4:
                aggregatedData = _a.sent();
                newPin.value.properties = aggregatedData[0].properties;
                _a.label = 5;
            case 5: return [2 /*return*/, newPin];
        }
    });
};
var watchZoomInPin = function () {
    var payload, viewport, pin;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(SearchMapAction_1.default.ZOOM_IN_PIN)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.select(RootSearchMapCallSaga_1.getViewport)];
            case 2:
                viewport = _a.sent();
                pin = payload;
                return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.setCamera({ center: { lat: pin.lat, lng: pin.lng }, zoom: viewport.zoom + 1 }))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchSetPinActive = function () {
    var payload, pin, viewport, forceUpdate, newPin, updatePins, i;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.take(SearchMapAction_1.default.SET_PIN_ACTIVE)];
            case 1:
                payload = (_a.sent()).payload;
                pin = payload;
                return [4 /*yield*/, effects_1.select(RootSearchMapCallSaga_1.getViewport)];
            case 2:
                viewport = _a.sent();
                forceUpdate = true;
                return [4 /*yield*/, effects_1.call(removeActivePins)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.call(fetchPropertiesToPin, pin)];
            case 4:
                newPin = _a.sent();
                updatePins = [];
                if (newPin.isCluster) {
                    for (i in newPin.value) {
                        updatePins.push(__assign(__assign({}, newPin.value[i]), { popupActive: true }));
                    }
                }
                else {
                    updatePins.push(__assign(__assign({}, newPin), { popupActive: true }));
                }
                return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.addCacheData({ pins: updatePins, viewport: viewport, forceUpdate: forceUpdate }))];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setNoscroll(true))];
            case 6:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.setCurrentActivePins(updatePins, viewport))];
            case 7:
                _a.sent();
                return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
};
var watchSetPinInactive = function () {
    var payload, pin, viewport, forceUpdate, activePins;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.take(SearchMapAction_1.default.SET_PIN_INACTIVE)];
            case 1:
                payload = (_a.sent()).payload;
                pin = payload;
                return [4 /*yield*/, effects_1.select(RootSearchMapCallSaga_1.getViewport)];
            case 2:
                viewport = _a.sent();
                forceUpdate = true;
                if (!pin.isCluster) return [3 /*break*/, 4];
                activePins = pin.value;
                return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.addCacheData({ pins: activePins.map(function (it) { return (__assign(__assign({}, it), { popupActive: false })); }), viewport: viewport, forceUpdate: forceUpdate }))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.addCacheData({ pins: [__assign(__assign({}, pin), { popupActive: false })], viewport: viewport, forceUpdate: forceUpdate }))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.setCurrentActivePins(null, null))];
            case 7:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(50)];
            case 8:
                _a.sent();
                return [3 /*break*/, 0];
            case 9: return [2 /*return*/];
        }
    });
};
var watchOnCancel = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(SearchMapAction_1.default.ON_CANCEL)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(removeActivePins)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchDistrictChangeAutoZoom = function () {
    var lastSearchQuery, _loop_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _loop_3 = function () {
                    var payload, searchQuery, currentViewport_1, lastSelectedDistricts, lastSelectedDistrictsLatLng, insideViewportCount;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, effects_1.take(SearchAction_1.default.USE_SEARCH_QUERY)];
                            case 1:
                                payload = (_a.sent()).payload;
                                searchQuery = payload;
                                if (!(!lastSearchQuery && !searchQuery.district)) return [3 /*break*/, 2];
                                return [3 /*break*/, 7];
                            case 2:
                                if (!(!lastSearchQuery || searchQuery.district !== lastSearchQuery.district)) return [3 /*break*/, 7];
                                if (!lastSearchQuery) return [3 /*break*/, 5];
                                return [4 /*yield*/, effects_1.select(RootSearchMapCallSaga_1.getViewport)];
                            case 3:
                                currentViewport_1 = _a.sent();
                                if (!(currentViewport_1 && currentViewport_1.bound)) return [3 /*break*/, 5];
                                return [4 /*yield*/, effects_1.select(getDistricts, lastSearchQuery.district.split(',').map(function (it) { return Number(it); }))];
                            case 4:
                                lastSelectedDistricts = _a.sent();
                                if (lastSelectedDistricts.length) {
                                    lastSelectedDistrictsLatLng = lastSelectedDistricts.map(function (it) { return it.location; });
                                    insideViewportCount = lastSelectedDistrictsLatLng.map(function (it) { return latLngContain_1.latLngContain(it, currentViewport_1.bound.ne, currentViewport_1.bound.sw); }).filter(function (it) { return it; }).length;
                                    if (insideViewportCount === 0) {
                                        lastSearchQuery = __assign({}, searchQuery);
                                        return [2 /*return*/, "continue"];
                                    }
                                }
                                _a.label = 5;
                            case 5: return [4 /*yield*/, effects_1.call(zoomToDistrict)];
                            case 6:
                                _a.sent();
                                _a.label = 7;
                            case 7:
                                lastSearchQuery = __assign({}, searchQuery);
                                return [2 /*return*/];
                        }
                    });
                };
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_3()];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
};
var watchKeywordChangeAutoZoom = function () {
    var currentZoomPropertyId, payload, response, hasKeyword, properties, property;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                currentZoomPropertyId = 0;
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.take(SearchMapAction_1.default.HANDLE_RESPONSE)];
            case 2:
                payload = (_a.sent()).payload;
                response = payload.response;
                if (!response.properties) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.select(getHasKeyword)];
            case 3:
                hasKeyword = _a.sent();
                properties = response.properties.filter(function (it) { return it.isRelated === 0; });
                if (properties.length !== 1)
                    return [3 /*break*/, 1];
                if (!hasKeyword)
                    return [3 /*break*/, 1];
                property = properties[0];
                if (!(currentZoomPropertyId !== property.id)) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.call(zoomToProperty, property)];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5:
                currentZoomPropertyId = property.id;
                _a.label = 6;
            case 6: return [3 /*break*/, 1];
            case 7: return [2 /*return*/];
        }
    });
};
var districtPointEnlarger = function (districtLocations, points) {
    if (districtLocations.find(function (it) { return it.id === 77; })) { // sai kung
        points.push({ lat: 22.475068, lng: 114.410287 });
        points.push({ lat: 22.337061, lng: 114.240269 });
    }
    if (districtLocations.find(function (it) { return it.id === 68; })) { // clearwater bay
        points.push({ lat: 22.359224, lng: 114.234239 });
        points.push({ lat: 22.260894, lng: 114.319507 });
    }
    return points;
};
var zoomToDistrict = function () {
    var districtLocations, viewportPixelWidth, viewportPixelHeight, districtPoints, points, isSmallScreen, camera;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(getSelectedDistrictLocations)];
            case 1:
                districtLocations = _a.sent();
                viewportPixelWidth = 856;
                viewportPixelHeight = 807;
                districtPoints = districtLocations ? districtLocations.map(function (it) { return it.location; }).filter(function (it) { return it; }) : [];
                points = districtPointEnlarger(districtLocations, districtPoints);
                if (!(!points || !points.length)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.select(WindowApi_1.getIsMobile)];
            case 2:
                isSmallScreen = _a.sent();
                return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.setCamera(isSmallScreen ? __assign(__assign({}, myokay_map3_1.defaultCamera), { zoom: 10 }) : myokay_map3_1.defaultCamera))];
            case 3:
                _a.sent();
                return [3 /*break*/, 7];
            case 4: return [4 /*yield*/, effects_1.call(getFittingCameraFromPoints_1.getFittingCameraFromPoints, points, viewportPixelWidth, viewportPixelHeight)];
            case 5:
                camera = _a.sent();
                return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.setCamera(__assign(__assign({}, camera), { zoom: Math.min(14, camera.zoom) })))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [2 /*return*/];
        }
    });
};
exports.zoomToDistrict = zoomToDistrict;
var zoomToProperty = function (property) {
    var center;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                center = { lat: Number(property.latitude), lng: Number(property.longitude) };
                return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.setCamera({ center: center, zoom: 19 }))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var getResultItemById = function (id) {
    var response, details, property, t, languageId, imgDomain, savedPropertyIds;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(SavePropertiesApiSaga_1.getPropertiesDetailByIdsApi, [id])];
            case 1:
                response = _a.sent();
                details = response.data.properties;
                if (!details || !details.length)
                    return [2 /*return*/, null];
                property = details[0];
                return [4 /*yield*/, effects_1.select(getResultPageTranslation)];
            case 2:
                t = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguage)];
            case 3:
                languageId = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getImageDomain)];
            case 4:
                imgDomain = _a.sent();
                return [4 /*yield*/, effects_1.call(UserPropertiesCrud_1.getSavedPropertyIds)];
            case 5:
                savedPropertyIds = _a.sent();
                return [4 /*yield*/, effects_1.call(searchResponseToResultPage_1.transformProperty, property, property.listingTypeId, t, languageId, imgDomain, savedPropertyIds.indexOf(id) >= 0)];
            case 6: return [2 /*return*/, _a.sent()];
        }
    });
};
var watchMapToggleFav = function () {
    var payload, id, item;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(SearchMapAction_1.default.MAP_TOGGLE_FAV)];
            case 1:
                payload = (_a.sent()).payload;
                id = payload;
                return [4 /*yield*/, effects_1.call(getResultItemById, id)];
            case 2:
                item = _a.sent();
                if (!item) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.put(ResultAction_1.default.onFavClicked(item))];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchResetMap = function () {
    var isSmallScreen, camera;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(SearchMapAction_1.default.RESET_MAP)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(WindowApi_1.getIsMobile)];
            case 2:
                isSmallScreen = _a.sent();
                camera = JSON.parse(JSON.stringify(myokay_map3_1.defaultCamera));
                return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.setCamera(isSmallScreen ? __assign(__assign({}, camera), { zoom: 10 }) : camera))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchShowMap = function () {
    var payload, mapHasPin;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.SET_MAP_ACTIVE)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.call(StorageApi_1.setCookie, 'activeMap', payload)];
            case 2:
                _a.sent();
                if (!(payload === false)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.call(WindowApi_1.updateSlider)];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4:
                ;
                return [4 /*yield*/, effects_1.select(getMapHasPin)];
            case 5:
                mapHasPin = _a.sent();
                if (!!mapHasPin) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.onSearchClick())];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
};
var watchShowMapLazyLoad = function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.SET_MAP_ACTIVE)];
            case 1:
                payload = (_a.sent()).payload;
                if (!(payload === false)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.delay(200)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.lazyLoadSliderImage)];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4:
                ;
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var rootSearchMapSagas = {
    watchInitCamera: watchInitCamera,
    watchMapViewInit: watchMapViewInit,
    watchOnViewportChanged: watchOnViewportChanged,
    watchHandleResponse: watchHandleResponse,
    watchSetPinActive: watchSetPinActive,
    watchSetPinInactive: watchSetPinInactive,
    watchOnCancel: watchOnCancel,
    watchPreloadAreaDistrict: watchPreloadAreaDistrict,
    watchRemoveActivePins: watchRemoveActivePins,
    watchDistrictChangeAutoZoom: watchDistrictChangeAutoZoom,
    watchKeywordChangeAutoZoom: watchKeywordChangeAutoZoom,
    watchMapToggleFav: watchMapToggleFav,
    watchResetMap: watchResetMap,
    watchDebounceSearch: watchDebounceSearch,
    watchShowMap: watchShowMap,
    watchShowMapLazyLoad: watchShowMapLazyLoad,
    watchZoomInPin: watchZoomInPin,
};
exports.rootSearchMapSagas = rootSearchMapSagas;
